<template>
  <div>
    <v-progress-circular
        v-if="isLoading"
        :size="70"
        :width="7"
        color="primary"
        indeterminate
        class="centered"
    />
    <div v-else>
      <h1 class="text-center mt-3">
        ประวัติการยกเลิกการเชื่อมต่อบัญชี Official Website
      </h1>

      <div class="form shadow p-5 mb-5 bg-white rounded">
        <div class="row">
          <div class="col-12 col-md-4 ">
            <BrandDropdown
                v-model="brandSelected"
                @setBrand="setBrand"
                @setBrands="setBrands"
            ></BrandDropdown>
            <div v-if="error.errorBrand" class="text-error">
              {{ error.errorBrand.message || 'กรุณาเลือก' }}
            </div>
          </div>

          <div class="col-12 col-md-4 ">
            <label for="customerCode">Customer Code</label>
            <input
                v-model="customerCode"
                type="text"
                class="form-control"
                @keyup.enter="searchUserRevocations"
            />
          </div>

          <div class="col-12 col-md-4 ">
            <label for="createdBy">Created by</label>
            <input
                v-model="createdBy"
                type="text"
                class="form-control"
                @keyup.enter="searchUserRevocations"
            />
          </div>
        </div>
        <div class="row mt-0">
          <div class="col-12 col-md-4 mb-3">
            <div class="form-group mb-3">
              <label for="start-date">Created date from</label>
              <VueCtkDateTimePicker
                  v-model="startDate"
                  :noLabel="true"
                  :format="'YYYY-MM-DDTHH:mm:ssZ'"
                  :formatted="'DD-MM-YYYY HH:mm'"
              />
            </div>
          </div>

          <div class="col-12 col-md-4 mb-3">
            <div class="form-group mb-3">
              <label for="end-date">Created date to</label>
              <VueCtkDateTimePicker
                  v-model="endDate"
                  :noLabel="true"
                  :format="'YYYY-MM-DDTHH:mm:ssZ'"
                  :formatted="'DD-MM-YYYY HH:mm'"
              />
            </div>
          </div>

          <div class="col-12 col-md-4 mb-3 d-flex align-items-end justify-content-end">
            <button
                class="btn btn-outline-secondary mr-2"
                @click="resetFilter"
            >
              Reset
            </button>
            <button
                class="btn btn-outline-success"
                @click="searchUserRevocations"
            >
              OK
            </button>
          </div>
        </div>

        <div class="mt-1">
          <div class="row mb-1">
            <div class="d-flex align-items-center justify-content-start col">
              <span>ผลการค้นหา: {{ totalItems }}</span>
            </div>
          </div>

          <b-table
              class="table table-bordered"
              hover
              responsive
              :fields="tableFields"
              :items="listUserRevocations"
              :busy="isBusy"
              @sort-changed="onSortChanged"
          >
            <template #cell(actions)="{ item }">

              <button
                  @click="
              $router.push({
                name: 'UserRevocationDetail',
                query: { id: item.id },
                params: { isRevoke: false }
              })
            "
                  class="btn btn-success btn-sm"
              >
                รายละเอียด
              </button>

            </template>
          </b-table>

          <b-pagination
              v-model="currentPage"
              :total-rows="totalItems"
              :per-page="perPage"
              class="my-0"
              @input="onPageChange"
          />
        </div>
      </div>
    </div>
    <v-dialog v-model="showDeductedDialog" max-width="500">
      <div class="deduct-dialog">
        <h3 class="deduct-title">ยกเลิกการเชื่อมต่อบัญชีสำเร็จ</h3>

        <div class="flex-fill">
          <p
              v-for="(item, index) in deductedPoints"
              :key="index"
              class="deduct-line"
          >
            คะแนนลูกค้าปี
            <span class="mx-2 my-0">{{ formatThaiYear(item.year) }}</span>
            ถูกปรับลดลง
            <span class="mx-2 my-0">{{ formatNumber(item.point) }}</span>
            คะแนน
          </p>
        </div>

        <div class="mt-3 text-right">
          <button
              class="btn btn-outline-success"
              @click="showDeductedDialog = false"
          >
            ปิด
          </button>
        </div>
      </div>
    </v-dialog>

  </div>
</template>

<script>
import BrandDropdown from "components/Brand/BrandDropdown.vue";
import OfficialWebsiteService from "services/api/officialWebsite.service";
import moment from "moment/moment";

export default {
  name: "UserRevocationsPage",
  components: {BrandDropdown},
  data() {
    return {
      isLoading: false,
      isBusy: false,
      isSubmit: false,
      brandSelected: null,
      customerCode: "",
      createdBy: "",
      startDate: null,
      endDate: null,
      listUserRevocations: [],
      tableFields: [
        {key: "brandName", label: "Brand", sortable: true},
        {key: "customerCode", label: "Customer code", sortable: true},
        {key: "dateCreated", label: "Revoke date", sortable: true},
        {key: "createdByFullName", label: "Created by", sortable: false},
        {key: "actions", label: "Actions"},
      ],
      currentPage: 1,
      perPage: 10,
      totalItems: 0,
      sortState: {key: "dateCreated", type: "desc"},
      error: {
        errorBrand: null,
        errorCustomerCode: null,
        errorCreatedBy: null,
      },
      showDeductedDialog: false,
      deductedPoints: [],
    };
  },
  mounted() {
    this.restoreFilterFromRoute();
    this.searchUserRevocations();
    this.checkDeductedDialog();
  },

  methods: {
    restoreFilterFromRoute() {
      const q = this.$route.query;
      if (!q || Object.keys(q).length === 0) {
        return;
      }

      if (q.brandCode) {
        this.brandSelected = q.brandCode;
      }

      this.customerCode = q.customerCode || "";
      this.createdBy = q.createdBy || "";
      this.startDate = q.startDate || null;
      this.endDate = q.endDate || null;
      this.currentPage = q.currentPage ? Number(q.currentPage) : 1;

      if (q.sortKey) {
        this.sortState = {
          key: q.sortKey,
          type: q.sortType || "desc",
        };
      }
    },
    searchUserRevocations() {
      this.isLoading = true;

      const brandCode =
          this.brandSelected && typeof this.brandSelected === "object"
              ? this.brandSelected.id
              : this.brandSelected || "";

      this.$router.replace({
        name: "UserRevocations",
        query: {
          brandCode,
          customerCode: this.customerCode || "",
          createdBy: this.createdBy || "",
          startDate: this.startDate || "",
          endDate: this.endDate || "",
          currentPage: String(this.currentPage),
          sortKey: this.sortState.key,
          sortType: this.sortState.type,
        },
      });

      this.getListUserRevocations(this.sortState);
    },

    async getListUserRevocations(sort) {
      const brandCode =
          this.brandSelected && typeof this.brandSelected === "object"
              ? this.brandSelected.id
              : this.brandSelected;

      const params = {
        brandCode: brandCode || null,
        customerCode: this.customerCode,
        createdBy: this.createdBy,
        dateTimeFrom: this.startDate,
        dateTimeTo: this.endDate,
        currentPage: this.currentPage,
        limit: this.perPage,
        sortColumn: sort.key === "brandName" ? "brandCode" : sort.key,
        sortType: sort.type === "asc" ? "asc" : "desc",
      };

      await OfficialWebsiteService.getListUserRevocations(params)
          .then((res) => {
            const data = res.data;
            this.totalItems = data.totalItems;
            this.listUserRevocations = data.revocations.map((c) => {
              const m = moment(c.dateCreated, moment.ISO_8601).locale("th");
              const date = m.format("YYYY-MM-DD HH:mm:ss");
              return {
                ...c,
                dateCreated: date,
              };
            });

            this.isLoading = false;
          })
          .catch((err) => {
            console.log("Error: ", err);
            this.isLoading = false;
          });
    },
    checkDeductedDialog() {
      const q = this.$route.query;

      if (q.showDeductedDialog === false) return;

      const raw = sessionStorage.getItem("lastDeductedPoints");

      if (raw !== null) {
        try {
          this.deductedPoints = JSON.parse(raw);
        } catch (error) {
          console.error("Invalid JSON in lastDeductedPoints:", error);
          this.deductedPoints = [];
        }
      }

      if (Array.isArray(this.deductedPoints) && this.deductedPoints.length > 0) {
        this.showDeductedDialog = true;
      }

      sessionStorage.removeItem("lastDeductedPoints");

      const { showDeductedDialog, ...rest } = q;
      this.$router.replace({ name: "UserRevocations", query: rest });
    },
    resetFilter() {
      this.isSubmit = false;
      this.brandSelected = null;
      this.startDate = null;
      this.endDate = null;
      this.customerCode = "";
      this.createdBy = "";
      this.currentPage = 1;
      this.totalItems = 0;
      this.listUserRevocations = [];
      this.resetErrorText();
      this.searchUserRevocations();
    },
    setBrand(brand) {
      this.brandSelected = brand || "";
    },

    setBrands(brands) {
      if (!this.brandSelected) return;

      const found = brands.find(
          (b) =>
              b.id === this.brandSelected ||
              b.code === this.brandSelected ||
              b.brandCode === this.brandSelected
      );

      if (found) {
        this.brandSelected = found; // ให้ dropdown ถือ object แทน string
      }
    },

    onPageChange(page) {
      this.currentPage = page;
      this.searchUserRevocations();
    },
    onSortChanged(e) {
      this.sortState = {
        key: e.sortBy,
        type: e.sortDesc ? "desc" : "asc",
      };
      this.getListUserRevocations(this.sortState);
    },
    formatThaiYear(year) {
      if (!year) return '-';
      return year + 543;
    },

    formatNumber(value) {
      if (value === null || value === undefined) return '0';
      return Number(value).toLocaleString('th-TH');
    },
    setErrorText(errors) {
      this.error.errorBrand = errors.find((e) => e.fieldName === "brandCode") || null;
      this.error.errorCustomerCode = errors.find((e) => e.fieldName === "customerCode") || null;
      this.error.errorCreatedBy = errors.find((e) => e.fieldName === "createdBy") || null;
    },
    resetErrorText() {
      this.error = {
        errorBrand: null,
        errorCustomerCode: null,
        errorCreatedBy: null,
      };
    },
  },
};
</script>

<style scoped>
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}
.deduct-dialog {
  background: #ffffff;
  padding: 32px 40px;
  border-radius: 4px;
  min-height: 220px;
  display: flex;
  flex-direction: column;
}

.deduct-title {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 24px;
}

.deduct-line {
  font-size: 16px;
  margin-bottom: 4px;
}

</style>
